/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactPaginate from "react-paginate";
import {
  addSplashScreen,
  deleteSplashScreen,
  getLanguageListForAdmin,
  getSplashScreenList,
  updateSplashScreen,
  updateSplashScreenStatus,
  uploadAudio,
  uploadImage,
} from "../../redux/slices/QuestionSlice";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToast, showSuccessToast } from "../../components/Toast/Toast";
import Loading from "../../components/Loader/Loader";
import ModalDefault from "../../components/ModalReport/Modal";
import { FiChevronLeft, FiChevronRight, FiTrash2 } from "react-icons/fi";
import GlobalSearchFilter from "../../components/Atoms/Global search/GlobalSearch";
import Table from "../../components/Atoms/Tables";
import { AiOutlineEdit, } from "react-icons/ai";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import ToggleButton from "../../components/Atoms/Toggle_Button/ToggleButton";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { MdOutlineBlock } from "react-icons/md";

const SplashScreen = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    showAfterQuestionNo: "",
    mediaType: "",
    durationInSeconds: "",
    translations: []
  });
  const [errorCreate, setErrorCreate] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState({});
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [openTab, setOpenTab] = useState(0);
  const size = 10;
  const selector = useSelector((state) => state.question);

  const mediaTypeOptions = ['image', 'video', 'none'];
  const [loading, setLoading] = useState({
    audio: false,
    image: false,
    submit: false,
  });

  const getSplashListData = selector?.getSplashScreenListData?.data?.list;
  const languages = selector?.getLanguageListForAdminData?.data?.list || [];
  const totalItems = selector?.getSplashScreenListData?.data?.total || 0;

  // Fetch splash screen list
  useEffect(() => {
    const fetchSplashList = async () => {
      try {
        setIsLoading(true);
        const reqData = {
          keyWord: searchText,
          pageNo: page + 1,
          size: size,
        };
        await dispatch(getSplashScreenList(reqData));
      } catch (error) {
        showErrorToast("Failed to load splash screens");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSplashList();
  }, [size, isRefresh, page, searchText]);

  // Fetch languages
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setIsLoading(true);
        const reqData = {
          keyWord: "",
          pageNo: 1,
          sortBy: "slug",
          sortOrder: "asc",
          fromDate: "",
          toDate: "",
          size: 150,
        };
        await dispatch(getLanguageListForAdmin(reqData));
      } catch (error) {
        toast.error("Failed to load languages");
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, [dispatch]);

  // Initialize translations when languages are loaded
  useEffect(() => {
    if (languages.length > 0 && !formData.translations.length) {
      const translations = languages.map((lang) => ({
        language: lang.shortName,
        title: "",
        description: "",
        mediaUrl: ""
      }));

      setFormData(prev => ({
        ...prev,
        translations,
        mediaType: mediaTypeOptions[0] // Set default media type
      }));
    }
  }, [languages]);

  // Form validation
  const validateForm = (isUpdate = false) => {
    const errors = {};

    if (!formData.showAfterQuestionNo) {
      errors.showAfterQuestionNo = "Question number is required";
    } else if (isNaN(formData.showAfterQuestionNo) || formData.showAfterQuestionNo < 0) {
      errors.showAfterQuestionNo = "Please enter a valid positive number";
    }

    if (!formData.mediaType) {
      errors.mediaType = "Media type is required";
    }

    if (!formData.durationInSeconds) {
      errors.durationInSeconds = "Duration is required";
    } else if (isNaN(formData.durationInSeconds) || formData.durationInSeconds <= 0) {
      errors.durationInSeconds = "Please enter a valid positive number";
    }

    formData.translations.forEach((trans, index) => {
      if (!trans.title) {
        errors[`title_${index}`] = "Title is required";
      } else if (trans.title.length > 100) {
        errors[`title_${index}`] = "Title must be less than 100 characters";
      }

      if (!trans.description) {
        errors[`description_${index}`] = "Description is required";
      } else if (trans.description.length > 500) {
        errors[`description_${index}`] = "Description must be less than 500 characters";
      }

      if (formData.mediaType !== 'none' && !trans.mediaUrl) {
        errors[`mediaUrl_${index}`] = "Media URL is required";
      } else if (trans.mediaUrl && trans.mediaUrl.length > 500) {
        errors[`mediaUrl_${index}`] = "Media URL must be less than 500 characters";
      }
    });

    return errors;
  };
  // Handle form submission for create
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrorCreate(formErrors);
      return;
    }

    setErrorCreate({});
    setLoading(prev => ({ ...prev, submit: true }));

    try {
      const reqData = {
        showAfterQuestionNo: parseInt(formData.showAfterQuestionNo),
        mediaType: formData.mediaType,
        durationInSeconds: parseInt(formData.durationInSeconds),
        isSkippable: true,
        translations: formData.translations.map(trans => ({
          language: trans.language,
          title: trans.title,
          description: trans.description,
          mediaUrl: trans.mediaUrl
        }))
      };

      const res = await dispatch(addSplashScreen(reqData)).unwrap();
      if (res?.error) {
        showErrorToast(res.message || "Failed to add splash screen");
        return;
      }

      showSuccessToast("Splash Screen Added Successfully!");
      setIsOpen(false);
      resetForm();
      setIsRefresh(!isRefresh);
    } catch (error) {
      console.error("Error adding splash screen:", error);
      showErrorToast(error.message || "Error in Adding Splash Screen");
    } finally {
      setLoading(prev => ({ ...prev, submit: false }));
    }
  };

  // Handle form submission for update
  const handleSubmitUpdate = async (e) => {
    e.preventDefault();
    const formErrors = validateForm(true);

    if (Object.keys(formErrors).length > 0) {
      setErrorUpdate(formErrors);
      return;
    }

    setErrorUpdate({});
    setLoading(prev => ({ ...prev, submit: true }));

    try {
      const reqData = {
        id: formData.id,
        showAfterQuestionNo: parseInt(formData.showAfterQuestionNo),
        mediaType: formData.mediaType,
        durationInSeconds: parseInt(formData.durationInSeconds),
        isSkippable: true,
        translations: formData.translations.map(trans => ({
          language: trans.language,
          title: trans.title,
          description: trans.description,
          mediaUrl: trans.mediaUrl
        }))
      };

      const res = await dispatch(updateSplashScreen(reqData)).unwrap();

      if (res?.error) {
        showErrorToast(res.message || "Failed to update splash screen");
        return;
      }

      showSuccessToast(res.message || "Splash Screen Updated Successfully!");
      setIsOpenUpdate(false);
      resetForm();
      setIsRefresh(!isRefresh);
    } catch (error) {
      console.error("Error updating splash screen:", error);
      showErrorToast(error.message || "Error in Updating Splash Screen");
    } finally {
      setLoading(prev => ({ ...prev, submit: false }));
    }
  };

  // Reset form to initial state
  const resetForm = () => {
    setFormData({
      showAfterQuestionNo: "",
      mediaType: mediaTypeOptions[0],
      durationInSeconds: "",
      translations: languages.map((lang) => ({
        language: lang.shortName,
        title: "",
        description: "",
        mediaUrl: ""
      }))
    });
  };

  // Handle delete splash screen
  const handleDelete = (splashScreen) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto text-center border border-gray-200">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 rounded-full flex items-center justify-center bg-gray-100">
                <FiTrash2 className="text-red-400" size={24} />
              </div>
            </div>
            <p className="text-gray-700 mb-6">
              Are you sure you want to delete this Splash Screen?
            </p>
            <div className="flex justify-center space-x-2">
              <button
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded text-gray-700 font-medium text-sm"
                onClick={onClose}
              >
                No, cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded text-white font-medium text-sm"
                onClick={async () => {
                  try {
                    setIsLoading(true);
                    const res = await dispatch(
                      deleteSplashScreen({ id: splashScreen._id })
                    ).unwrap();

                    if (res.error) {
                      showErrorToast(res.message || "Error In Deleting");
                      return;
                    }

                    showSuccessToast(res?.message || "Splash Screen deleted successfully");
                    setIsRefresh(prev => !prev);
                  } catch (error) {
                    showErrorToast(
                      error?.message || "Failed to delete Splash Screen"
                    );
                  } finally {
                    setIsLoading(false);
                    onClose();
                  }
                }}
              >
                Yes, I'm sure
              </button>
            </div>
          </div>
        );
      },
    });
  };

  // Handle status toggle
  const handleStatusToggle = (splashScreen) => {
    const action = splashScreen.isActive ? "true" : "false";

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto text-center border border-gray-200">
            <div className="flex justify-center mb-4">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center ${splashScreen.false ? "bg-green-100" : "bg-red-100"
                }`}>
                {splashScreen.false ? (
                  <HiOutlineCheckCircle className="text-lg text-green-500" />
                ) : (
                  <MdOutlineBlock className="text-red-400" size={24} />
                )}
              </div>
            </div>
            <p className="text-gray-700 mb-6">
              Are you sure you want to {action} this Splash Screen?
            </p>
            <div className="flex justify-center space-x-2">
              <button
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded text-gray-700 font-medium text-sm"
                onClick={onClose}
              >
                No, cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded text-white font-medium text-sm"
                onClick={async () => {
                  try {
                    setIsLoading(true);
                    const res = await dispatch(
                      updateSplashScreenStatus({ id: splashScreen._id })
                    ).unwrap();

                    if (res.error) {
                      showErrorToast(res.message || "Failed to update status");
                      return;
                    }

                    showSuccessToast(res?.message || `Splash Screen ${action}d successfully`);
                    setIsRefresh(prev => !prev);
                  } catch (error) {
                    showErrorToast(error?.message || "Failed to update status");
                  } finally {
                    setIsLoading(false);
                    onClose();
                  }
                }}
              >
                Yes, I'm sure
              </button>
            </div>
          </div>
        );
      },
    });
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when field is changed
    if (errorCreate[name]) {
      setErrorCreate(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
    if (errorUpdate[name]) {
      setErrorUpdate(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
  };

  // Handle translation field changes
  const handleTranslationChange = (e, index) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const newTranslations = [...prev.translations];
      newTranslations[index] = {
        ...newTranslations[index],
        [name]: value
      };

      return {
        ...prev,
        translations: newTranslations
      };
    });

    // Clear error when field is changed
    if (errorCreate[`${name}_${index}`]) {
      setErrorCreate(prev => ({
        ...prev,
        [`${name}_${index}`]: undefined
      }));
    }
  };

  // Handle media upload (simulated for demo
  const handleMediaUpload = async (e, index) => {
    const file = e.target.files[0];

    const isImage = file.type.startsWith("image/");
    if (!file) return;


    const formData = new FormData();
    formData.append(isImage ? "image" : "audio", file);

    try {
      setIsLoading(true);

      const uploadAction = isImage ? uploadImage : uploadAudio;
      const response = await dispatch(uploadAction(formData)).unwrap();

      const url = response?.imageURL || response?.audioURL;

      if (url) {
        setFormData(prev => {
          const newTranslations = [...prev.translations];
          newTranslations[index] = {
            ...newTranslations[index],
            mediaUrl: url
          };

          return {
            ...prev,
            translations: newTranslations
          };
        });
      
        return url;
      }
    } catch (error) {
      toast.error(`Failed to upload ${isImage}`);
      return null;
    } finally {
        setIsLoading(false);
    }
  };

  // Prepare data for edit modal
  const prepareEditData = (splashScreen) => {
    const translations = languages.map(lang => {
      const existingTranslation = splashScreen.translations.find(
        t => t.language === lang.shortName
      );

      return existingTranslation || {
        language: lang.shortName,
        title: "",
        description: "",
        mediaUrl: ""
      };
    });

    setFormData({
      id: splashScreen._id,
      showAfterQuestionNo: splashScreen.showAfterQuestionNo,
      mediaType: splashScreen.mediaType,
      durationInSeconds: splashScreen.durationInSeconds,
      translations
    });

    setIsOpenUpdate(true);
  };
  return (
    <>
      <Loading loading={isLoading || selector?.loading} />
      <div className="w-full overflow-y-scroll py-3 md:px-5 px-1">
        <GlobalSearchFilter
          title={`Splash Screen`}
          buttonLabel={`Add Splash Screen`}
          onAddClick={() => {
            resetForm();
            setErrorCreate({});
            setIsOpen(true);
          }}
          showExportButton={false}
          searchKeyword={searchText}
          onSearchChange={(e) => {
            setSearchText(e.target.value);
            setPage(0);
          }}
          placeholder={`Search by Media Type..`}
        />

        <div className="w-full h-full max-w-[100vw]">
          <Table
            headers={{
              title: "Title",
              description: "Description",
              mediaType: "Media Type",
              showAfterQuestionNo: "Show After Question No.",
              mediaUrl: "Media Preview",
              language: "Language",
              status: "Status",
              action: "Action",
            }}
            list={
              getSplashListData && getSplashListData.length > 0 ? (
                getSplashListData.map((ele, index) => {

                  const enData = ele?.translations.find((el) => el.language === "en")

                  return {
                    title: enData?.title || "--",
                    description: enData?.description || "—",
                    mediaType: <span className="capitalize">{ele?.mediaType || "—"}</span>,
                    showAfterQuestionNo: ele?.showAfterQuestionNo || "—",
                    mediaUrl: (
                      <div className="w-32 h-20 rounded overflow-hidden border border-gray-200">
                        {enData.mediaType === 'video' ? (
                          <video controls width="100%" height="100%" className="object-cover">
                            <source src={enData.mediaUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : ele.mediaType === 'image' ? (
                          <img
                            src={enData.mediaUrl}
                            alt={enData.language}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center bg-gray-100">
                            No Media
                          </div>
                        )}
                      </div>),
                    language: ele?.translations?.map(t => t.language).join(', ') || "—",
                    status: (
                      <div className="mt-2">
                        <ToggleButton
                          isOn={ele.isActive}
                          onLabel="Disabled"
                          offLabel="Enabled"
                          onToggle={() => handleStatusToggle(ele)}
                        />

                      </div>

                    ),
                    action: (
                      <div className="mt-4 flex justify-end gap-4">
                        <button
                          onClick={() => prepareEditData(ele)}
                          className="p-2 shadow text-[#1E5EFF] border border-[#D7DBEC] rounded hover:bg-blue-100 transition-colors duration-200"
                          aria-label="Edit"
                        >
                          <AiOutlineEdit className="text-lg" />
                        </button>
                        <button
                          onClick={() => handleDelete(ele)}
                          className="p-2 shadow text-red-500 border border-[#D7DBEC] rounded hover:bg-blue-100 transition-colors duration-200"
                          aria-label="Delete"
                        >
                          <FiTrash2 className="h-4 w-4" />
                        </button>
                      </div>
                    ),
                  }
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4">No Data Available</td>
                </tr>
              )
            }
            size={size}
            pageNo={page}
            total={totalItems}
          />

          {totalItems > size && (
            <div className="px-4 py-3 flex items-end justify-end border-t border-[#E6E9F4] sm:px-6">
              <ReactPaginate
                previousLabel={<FiChevronLeft className="h-5 w-5" />}
                nextLabel={<FiChevronRight className="h-5 w-5" />}
                breakLabel={"..."}
                pageCount={Math.ceil(totalItems / size)}
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={({ selected }) => setPage(selected)}
                containerClassName={"flex items-center gap-1"}
                pageClassName={"px-3 py-1 rounded-md border border-gray-300"}
                pageLinkClassName={"text-sm font-medium"}
                activeClassName={"bg-blue-500 text-white border-blue-500"}
                previousClassName={"p-1 rounded-md border border-gray-300"}
                nextClassName={"p-1 rounded-md border border-gray-300"}
                disabledClassName={"opacity-50 cursor-not-allowed"}
                forcePage={page}
              />
            </div>
          )}
        </div>
      </div>

      {/* Add Splash Screen Modal */}
      <ModalDefault
        isOpen={isOpen}
        title="Add Splash Screen"
        closeModal={() => {
          setIsOpen(false);
          setErrorCreate({});
          resetForm();
        }}
      >
        <div className="">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Show After Question No
                </label>
                <input
                  type="number"
                  name="showAfterQuestionNo"
                  value={formData.showAfterQuestionNo}
                  onChange={handleChange}
                  min="0"
                  className={`w-full border ${errorCreate.showAfterQuestionNo ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                  placeholder="Enter question number"
                />
                {errorCreate.showAfterQuestionNo && (
                  <p className="mt-1 text-sm text-red-600">{errorCreate.showAfterQuestionNo}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Media Type
                </label>
                <select
                  name="mediaType"
                  value={formData.mediaType}
                  onChange={handleChange}
                  className={`w-full border ${errorCreate.mediaType ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                >
                  {mediaTypeOptions.map((option, index) => (
                    <option key={index} value={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</option>
                  ))}
                </select>
                {errorCreate.mediaType && (
                  <p className="mt-1 text-sm text-red-600">{errorCreate.mediaType}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Duration (seconds)
                </label>
                <input
                  type="number"
                  name="durationInSeconds"
                  value={formData.durationInSeconds}
                  onChange={handleChange}
                  min="1"
                  className={`w-full border ${errorCreate.durationInSeconds ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                  placeholder="Enter duration"
                />
                {errorCreate.durationInSeconds && (
                  <p className="mt-1 text-sm text-red-600">{errorCreate.durationInSeconds}</p>
                )}
              </div>
            </div>

            {/* Language tabs */}
            <div className="space-y-2">
              {formData.translations?.map((translation, index) => (
                <div key={index} className="">
                  {/* Language tab header */}
                  <button
                    type="button"
                    className={`w-full flex justify-between items-center p-2 ${openTab === index ? "bg-[#C7C7C7]" : "bg-gray-200"} transition-colors`}
                    onClick={() => setOpenTab(openTab === index ? -1 : index)}
                  >
                    <span className="text-gray-700">
                      {languages.find(l => l.shortName === translation.language)?.name || translation.language}
                    </span>
                    {openTab === index ? (
                      <FaMinus className="text-gray-500" />
                    ) : (
                      <FaPlus className="text-gray-500" />
                    )}
                  </button>

                  {/* Language content (collapsible) */}
                  {openTab === index && (
                    <div className="space-y-3 bg-white p-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Title *
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={translation.title}
                          onChange={(e) => handleTranslationChange(e, index)}
                          maxLength={100}
                          className={`w-full border ${errorCreate[`title_${index}`] ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                          placeholder="Enter title"
                        />
                        {errorCreate[`title_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">{errorCreate[`title_${index}`]}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Description
                        </label>
                        <textarea
                          name="description"
                          value={translation.description}
                          onChange={(e) => handleTranslationChange(e, index)}
                          rows={3}
                          maxLength={500}
                          className={`w-full border ${errorCreate[`description_${index}`] ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                          placeholder="Enter description"
                        />
                        {errorCreate[`description_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">{errorCreate[`description_${index}`]}</p>
                        )}
                      </div>

                      {formData.mediaType !== 'none' && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            {formData.mediaType === 'video' ? 'Video URL *' : 'Image URL *'}
                          </label>
                          <div className="flex items-center gap-2">
                            <label className="cursor-pointer bg-blue-500 text-white px-3 py-2 rounded-md hover:bg-blue-600">
                              Upload
                              <input
                                type="file"
                                accept={formData.mediaType === 'video' ? 'video/*' : 'image/*'}
                                className="hidden"
                                onChange={(e) => handleMediaUpload(e, index)}
                              />
                            </label>
                          </div>
                          {errorCreate[`mediaUrl_${index}`] && (
                            <p className="mt-1 text-sm text-red-600">{errorCreate[`mediaUrl_${index}`]}</p>
                          )}

                          {translation.mediaUrl && (
                            <div className="mt-2">
                              {formData.mediaType === 'video' ? (
                                <video controls className="w-full max-h-40 rounded-md border">
                                  <source src={translation.mediaUrl} type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                              ) : (
                                <img
                                  src={translation.mediaUrl}
                                  alt="Preview"
                                  className="w-full max-h-40 object-contain rounded-md border"
                                />
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <button
              type="submit"
              disabled={loading.submit}
              className="mt-4 bg-blue-500 w-full text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600 disabled:bg-blue-300"
            >
              {loading.submit ? (
                <>
                  <CircularProgress size={20} className="mr-2" />
                  Submitting...
                </>
              ) : 'Submit'}
            </button>
          </form>
        </div>
      </ModalDefault>

      {/* Update Splash Screen Modal */}
      <ModalDefault
        isOpen={isOpenUpdate}
        title="Update Splash Screen"
        closeModal={() => {
          setIsOpenUpdate(false);
          setErrorUpdate({});
          resetForm();
        }}
      >
        <div className="">
          <form onSubmit={handleSubmitUpdate}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Show After Question No
                </label>
                <input
                  type="number"
                  name="showAfterQuestionNo"
                  value={formData.showAfterQuestionNo}
                  onChange={handleChange}
                  min="0"
                  className={`w-full border ${errorUpdate.showAfterQuestionNo ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                />
                {errorUpdate.showAfterQuestionNo && (
                  <p className="mt-1 text-sm text-red-600">{errorUpdate.showAfterQuestionNo}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Media Type
                </label>
                <select
                  name="mediaType"
                  value={formData.mediaType}
                  onChange={handleChange}
                  className={`w-full border ${errorUpdate.mediaType ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                >
                  {mediaTypeOptions.map((option, index) => (
                    <option key={index} value={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</option>
                  ))}
                </select>
                {errorUpdate.mediaType && (
                  <p className="mt-1 text-sm text-red-600">{errorUpdate.mediaType}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Duration (seconds)
                </label>
                <input
                  type="number"
                  name="durationInSeconds"
                  value={formData.durationInSeconds}
                  onChange={handleChange}
                  min="1"
                  className={`w-full border ${errorUpdate.durationInSeconds ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                />
                {errorUpdate.durationInSeconds && (
                  <p className="mt-1 text-sm text-red-600">{errorUpdate.durationInSeconds}</p>
                )}
              </div>
            </div>

            {/* Language tabs for update */}
            <div className="space-y-2">
              {formData.translations?.map((translation, index) => (
                <div key={index} className="">
                  <button
                    type="button"
                    className={`w-full flex justify-between items-center p-2 ${openTab === index ? "bg-[#C7C7C7]" : "bg-gray-200"} transition-colors`}
                    onClick={() => setOpenTab(openTab === index ? -1 : index)}
                  >
                    <span className="text-gray-700">
                      {languages.find(l => l.shortName === translation.language)?.name || translation.language}
                    </span>
                    {openTab === index ? (
                      <FaMinus className="text-gray-500" />
                    ) : (
                      <FaPlus className="text-gray-500" />
                    )}
                  </button>

                  {openTab === index && (
                    <div className="space-y-3 bg-white p-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Title *
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={translation.title}
                          onChange={(e) => handleTranslationChange(e, index)}
                          maxLength={100}
                          className={`w-full border ${errorUpdate[`title_${index}`] ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                        />
                        {errorUpdate[`title_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">{errorUpdate[`title_${index}`]}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Description *
                        </label>
                        <textarea
                          name="description"
                          value={translation.description}
                          onChange={(e) => handleTranslationChange(e, index)}
                          rows={3}
                          maxLength={500}
                          className={`w-full border ${errorUpdate[`description_${index}`] ? "border-red-500" : "border-gray-300"} rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500`}
                        />
                        {errorUpdate[`description_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">{errorUpdate[`description_${index}`]}</p>
                        )}
                      </div>

                      {formData.mediaType !== 'none' && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            {formData.mediaType === 'video' ? 'Video URL *' : 'Image URL *'}
                          </label>
                          <div className="flex items-center gap-2">
                            <label className="cursor-pointer bg-blue-500 text-white px-3 py-2 rounded-md hover:bg-blue-600">
                              Upload
                              <input
                                type="file"
                                accept={formData.mediaType === 'video' ? 'video/*' : 'image/*'}
                                className="hidden"
                                onChange={(e) => handleMediaUpload(e, index)}
                              />
                            </label>
                          </div>
                          {errorUpdate[`mediaUrl_${index}`] && (
                            <p className="mt-1 text-sm text-red-600">{errorUpdate[`mediaUrl_${index}`]}</p>
                          )}

                          {translation.mediaUrl && (
                            <div className="mt-2">
                              {formData.mediaType === 'video' ? (
                                <video controls className="w-full max-h-40 rounded-md border">
                                  <source src={translation.mediaUrl} type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                              ) : (
                                <img
                                  src={translation.mediaUrl}
                                  alt="Preview"
                                  className="w-full max-h-40 object-contain rounded-md border"
                                />
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <button
              type="submit"
              disabled={loading.submit}
              className="mt-4 bg-blue-500 w-full text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600 disabled:bg-blue-300"
            >
              {loading.submit ? (
                <>
                  <CircularProgress size={20} className="mr-2" />
                  Updating...
                </>
              ) : 'Update'}
            </button>
          </form>
        </div>
      </ModalDefault>
    </>
  );
};

export default SplashScreen;